// Breadcrumb 'Produto › Grupo › Tela' no header (PO1-1974).
//
// Substitui o brandText simples do AdminNavbar. Mostra:
//   [Icon] Produto › Grupo › Tela
// quando o produto ativo está definido. Em loading ou setor=transportadora
// (sem produto), mostra fallback (o brandText legado).
//
// Sprint 638: em 2 treinamentos o usuário clicou no nome do produto achando que
// trocaria de produto. Agora troca: ícone + nome viram um botão que abre o mesmo
// seletor do ícone de lista do cabeçalho (AppSwitcher, mesmos produtos e mesma
// ação). Grupo e tela continuam texto.

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

import AppSwitcher from "../AppSwitcher/AppSwitcher";

import { useActiveProduct } from "../../hooks/activeProduct";
import {
  PRODUCT_META,
  findBreadcrumbInProduct,
} from "../../routes/products";

import "./ProductBreadcrumb.css";

const Sep = () => <span className="product-breadcrumb__sep">›</span>;

const ProductBreadcrumb = ({ fallback }) => {
  const { activeProduct } = useActiveProduct();
  const location = useLocation();
  const [trocaAberta, setTrocaAberta] = useState(false);

  if (!activeProduct || !PRODUCT_META[activeProduct]) {
    return <span className="product-breadcrumb">{fallback || ""}</span>;
  }

  const meta = PRODUCT_META[activeProduct];
  const Icon = meta.icon;
  const { groupName, screenName } = findBreadcrumbInProduct(
    activeProduct,
    location.pathname,
  );

  return (
    <span className="product-breadcrumb">
      <Dropdown
        isOpen={trocaAberta}
        toggle={() => setTrocaAberta((v) => !v)}
        className="product-breadcrumb__troca"
        tag="span"
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="product-breadcrumb__botao"
          aria-label={`Produto ${meta.label}. Trocar produto`}
          aria-haspopup="true"
          aria-expanded={trocaAberta}
          title="Trocar produto"
        >
          {meta.iconImage ? (
            <span
              className="product-breadcrumb__icon"
              style={{ color: meta.color }}
            >
              <img
                src={meta.iconImage}
                alt=""
                style={{ width: 20, height: 20, objectFit: "contain" }}
              />
            </span>
          ) : Icon ? (
            <span
              className="product-breadcrumb__icon"
              style={{ color: meta.color }}
            >
              <Icon size={20} />
            </span>
          ) : null}
          <span
            className="product-breadcrumb__product"
            style={{ color: meta.color }}
          >
            {meta.label}
          </span>
          <span className="product-breadcrumb__caret" aria-hidden="true" />
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-navbar dropdown-app-switcher product-breadcrumb__menu"
          tag="ul"
        >
          <DropdownItem header>Trocar Para</DropdownItem>
          <AppSwitcher />
        </DropdownMenu>
      </Dropdown>
      {groupName ? (
        <>
          <Sep />
          <span className="product-breadcrumb__group">{groupName}</span>
        </>
      ) : null}
      {screenName ? (
        <>
          <Sep />
          <span className="product-breadcrumb__screen">{screenName}</span>
        </>
      ) : null}
    </span>
  );
};

export default ProductBreadcrumb;
